module.exports = __webpack_public_path__ + "img/mmanresa-min.a21ffb05.jpeg";